import React, { createContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

export const DateContext = createContext();
const DateContextProvider = ({ children }) => {
  const mstPhoenixDate = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Phoenix' }));
  const formattedDate = mstPhoenixDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  const [selectedDate, setSelectedDate] = useState(formattedDate);
  const contextValue = useMemo(() => ({ selectedDate, setSelectedDate, formattedDate }),
    [formattedDate, selectedDate]);
  return (
    <DateContext.Provider value={contextValue}>
      {children}
    </DateContext.Provider>
  );
};
export default DateContextProvider;
DateContextProvider.propTypes = {
  children: PropTypes.node,
};
